import styles from './CardCarrinho.module.css';
import { HiOutlineTrash } from 'react-icons/hi';

function CardCarrinho({ id, src, label_title, preco, excluirItem, observacao, quantidade }) {
  const subtotal = (parseFloat(preco) * (quantidade || 1)).toFixed(2);

  return (
    <div className={styles.itemdocarrinho}>
      {/* imagem */}
      <img src={src} alt={label_title} className={styles.imagemItem} />

      {/* infos principais */}
      <div className={styles.itemInfo}>
        <div className={styles.linhaInfo}>
          <p className={styles.nomeDoItem}>{label_title}</p>
          <p className={styles.precoDoItem}>R$ {subtotal}</p>
        </div>
        {observacao && (
          <p className={styles.observacaoItem}>Obs: {observacao}</p>
        )}
        <div className={styles.quantidadeInfo}>
          <span>Quantidade: {quantidade || 1}</span>
        </div>
      </div>

      {/* botão excluir */}
      <button
        className={styles.buttonExcluirItem}
        onClick={() => excluirItem(id)}
        title="Remover item"
        aria-label="Remover item"
      >
        <HiOutlineTrash />
      </button>
    </div>
  );
}

export default CardCarrinho;
